import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-edit-payment-plan',
    templateUrl: './edit-payment-plan.component.html',
    imports: [RouterOutlet]
})
export class EditPaymentPlanComponent {
}
